import { html } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './action-bar.lit.scss';

/**
 * @component {kat-action-bar} KatActionBar The action bar provides a standard way to place and organize multiple actions.
 * @slot default Core action buttons.
 * @slot actions Low priority action buttons.
 * @status Production
 * @example Default {"content": "<kat-button>Positive</kat-button><kat-button variant=\"secondary\">Neutral</kat-button><kat-button variant=\"secondary\">Negative</kat-button><kat-button variant=\"tertiary\" slot=\"low-priority\">Cancel</kat-button>"}
 * @a11y {keyboard}
 * @a11y {sr}
 * @a11y {contrast}
 */
@register('kat-action-bar')
export class KatActionBar extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  render() {
    return html`<div class="actions-core"><slot></slot></div>
      <div class="actions-low-priority">
        <slot name="low-priority"></slot>
      </div>`;
  }
}
